module.exports = __webpack_public_path__ + "img/发展历程图.e5e04d10.jpg";